document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    setTimeout( () => {
        document.querySelectorAll('.swiper-slider').forEach((element,i) => {

            let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
            element.setAttribute(`data-swiper-${i}`,"");
            let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
            allSwipper[i] = swiper;
        });
    }, 2000);

    if( document.querySelector('.slider__slider')) {
        let quadSlider = new Swiper('.slider__slider',{
            speed: 700,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            // autoplay: {
            //     delay: 10000,
            //     disableOnInteraction: false
            // },
            uniqueNavElements: false,
            // pagination: {
            //     el: '.slider-pagination',
            //     clickable: true
            // },
            navigation: {
                prevEl: '.slider-arrow-prev',
                nextEl: '.slider-arrow-next'
            }
        });
    }

    if( document.querySelector('.gallery-quad__all-sliders')) {
    
        let sliderLeft = new Swiper('.gallery-quad__slider-left',{
            loop: true,
            speed: 800,
            slidesPerView: 1,
            allowTouchMove: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                prevEl: '.gallery-arrow-prev',
                nextEl: '.gallery-arrow-next'
            }
        });

        let sliderRight = new Swiper('.gallery-quad__slider-right',{
            loop: true,
            speed: 800,
            slidesPerView: 1,
            allowTouchMove: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            }
        });

        let sliderCenter = new Swiper('.gallery-quad__slider-center',{
            loop: true,
            speed: 800,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                prevEl: '.gallery-arrow-prev',
                nextEl: '.gallery-arrow-next'
            }
        });

        sliderCenter.controller.control = [sliderLeft,sliderRight];
    }
    

 if( document.querySelector('.gallery-mobile__mobile')) {    
    let gallerymobileSlider = new Swiper('.gallery-mobile__mobile',{
        loop: true,
        speed: 800,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.gallery-arrow-prev',
            nextEl: '.gallery-arrow-next'
        }
    });
}
 if( document.querySelector('.packages__slider')) {
    let packagesSlider = new Swiper('.packages__slider',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: '.packages-pagination',
            clickable: true
        },
        breakpoints: {
            650: {
                slidesPerView: 2,
                spaceBetween: 30,
                spaceBetween: 15
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 40,
                spaceBetween: 20
            }
        }
    })
}
});